import axiosInstance from "../../api/axiosConfig";
import { GET_ALL_CLIENTS_ADMIN, GET_CLIENT_BY_ID } from "./ClientQuery.ts";
import logger from "../../utils/logger";

const API_URL = "/clients";
const API_GQL_URL = "/gql";

function getAuthHeaders() {
    const token = localStorage.getItem('turnlinkToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
}

//Actualizados con autenticación

const updateClientSelf = async (clientId, updateData, selectedFiles) => {
    try {
        const formData = new FormData();
        formData.append('updateDto', JSON.stringify(updateData));

        // Manejar archivos de servicios (objeto con índices como claves)
        if (selectedFiles && typeof selectedFiles === 'object' && !Array.isArray(selectedFiles)) {
            Object.entries(selectedFiles).forEach(([serviceIndex, files]) => {
                if (Array.isArray(files)) {
                    files.forEach((file, imgIndex) => {
                        // Construimos nombre de archivo con convención reconocible por el backend
                        const fileExtension = file.name.split('.').pop();
                        const fileName = `service${parseInt(serviceIndex) + 1}_img${imgIndex + 1}.${fileExtension}`;
                        formData.append('images', file, fileName);
                    });
                }
            });
        }
        
        // Manejar archivos de logo (array simple)
        if (selectedFiles && Array.isArray(selectedFiles)) {
            selectedFiles.forEach((file) => {
                formData.append('images', file, `logo_${file.name}`);
            });
        }

        const response = await axiosInstance.put(`${API_URL}/self/${clientId}`, formData, {
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'multipart/form-data',
            },
            timeout: 90000 // 90 segundos
        });
        return response.data;
    } catch (error) {
        logger.error("Error updating client self:", error);
        throw error;
    }
};

const getClientDataById = async (clientId) => {
    try {
        const response = await axiosInstance.post(API_GQL_URL, {
            query: GET_CLIENT_BY_ID,
            variables: { id: clientId }
        }, { headers: getAuthHeaders() });
        return response.data.data.getClientById;
    } catch (error) {
        logger.error("Error fetching client data:", error);
        throw error;
    }
};

const getWhatsAppQr = async (clientId) => {
    try {
        const response = await axiosInstance.get(`/whatsapp/qr/${clientId}`, {
            headers: getAuthHeaders(),
            timeout: 180000 // 3 minutos
        });
        return response.data;
    } catch (error) {
        logger.error("Error fetching WhatsApp QR:", error);
        throw error;
    }
};

const getWhatsAppPairingCode = async (clientId, phoneNumber) => {
    try {
        const response = await axiosInstance.post(
            `/whatsapp/pairing-code/${clientId}`,
            { phoneNumber },
            {
                headers: getAuthHeaders(),
                timeout: 180000 // 3 minutos
            }
        );
        return response.data;
    } catch (error) {
        logger.error("Error fetching WhatsApp pairing code:", error);
        throw error;
    }
};

const getAllClients = async () => {
    try {
        const response = await axiosInstance.post(API_GQL_URL, {
            query: GET_ALL_CLIENTS_ADMIN
        }, { headers: getAuthHeaders() });
        return response.data.data.getAllClientsAdmin;
    } catch (error) {
        logger.error("Error fetching all clients:", error);
        throw error;
    }
};

const addStaff = async (clientId, nombreStaff, accountData = null) => {
    try {
        const payload = { nombreStaff };
        
        // Si se proporciona accountData, agregarlo al payload
        if (accountData) {
            const user = {
                username: accountData.username,
                password: accountData.password
            }
            payload.user = user;
        }
        
        const response = await axiosInstance.post(`/clients/${clientId}/staff`, payload,
            { headers: getAuthHeaders() }
        );
        return response.data; // { staffId, name, status }
    } catch (error) {
        logger.error("Error adding staff:", error);
        throw error;
    }
};

const deleteStaff = async (clientId, staffId) => {
    try {
        const response = await axiosInstance.delete(`/clients/${clientId}/staff/${staffId}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error deleting staff:", error);
        throw error;
    }
};

/**
 * Actualiza datos de un staff específico (horarios, nombre, estado, avatar, etc.)
 * Sin perder información existente - usa merge automático
 */
const updateStaffData = async (clientId, staffId, updateData) => {
    try {
        const response = await axiosInstance.put(
            `/clients/${clientId}/staff/${staffId}`,
            updateData,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error) {
        logger.error("Error updating staff data:", error);
        throw error;
    }
};

/** Perillas del asistente con IA (add-on aiAssistant): enabled, name, tone, extraInfo. Solo el dueño; el tope lo fija el superadmin. */
const updateAssistantSettings = async (clientId, assistant) => {
    try {
        const response = await axiosInstance.put(`/clients/${clientId}/assistant-settings`, assistant, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        logger.error("Error updating assistant settings:", error);
        throw error;
    }
};

/** Uso del mes del asistente con IA ("312 de 1,500 conversaciones"). 403 ADDON_REQUIRED sin el add-on. */
const getAssistantUsage = async (clientId) => {
    const response = await axiosInstance.get(`/assistant/${clientId}/usage`, { headers: getAuthHeaders() });
    return response.data;
};

const updatePaymentSettings = async (clientId, paymentSettings) => {
    try {
        const response = await axiosInstance.put(`/clients/${clientId}/payment-settings`, 
            paymentSettings,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error) {
        logger.error("Error updating payment settings:", error);
        throw error;
    }
};


//superadmin
const createClient = async (clientData) => {
    try {
        const response = await axiosInstance.post(API_URL, clientData, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error creating client:", error);
        throw error;
    }
};

const changePassword = async (clientId, passwordData) => {
    try {
        const response = await axiosInstance.put(`${API_URL}/self/${clientId}/password`, passwordData, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error changing password:", error);
        throw error;
    }
};

const updateClient = async (clientId, updateData) => {
    try {
        const response = await axiosInstance.put(`${API_URL}/${clientId}`, updateData, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error updating client:", error);
        throw error;
    }
};

const subscribeNotifications = async (subscriptionData) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/push/subscribe`, subscriptionData, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error subscribing to notifications:", error);
        throw error;
    }
}

const subscribeStaffNotifications = async (subscriptionData) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/staff/push/subscribe`, subscriptionData, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error subscribing staff to notifications:", error);
        throw error;
    }
}

// superadmin: configuración de plataforma
const getSystemConfig = async () => {
    try {
        const response = await axiosInstance.get(`/system-config`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error fetching system config:", error);
        throw error;
    }
};

const updateSystemConfig = async (data) => {
    try {
        const response = await axiosInstance.put(`/system-config`, data, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error updating system config:", error);
        throw error;
    }
};

// superadmin: pagos manuales SPEI
const registerPayment = async (paymentData) => {
    try {
        const response = await axiosInstance.post(`/payments`, paymentData, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error registering payment:", error);
        throw error;
    }
};

const getPayments = async (clientId) => {
    try {
        const response = await axiosInstance.get(`/payments/${clientId}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        logger.error("Error fetching payments:", error);
        throw error;
    }
};

const reorderServices = async (clientId, services) => {
    try {
        const response = await axiosInstance.put(`${API_URL}/self/${clientId}/services/reorder`,
            { services },
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error) {
        logger.error("Error reordering services:", error);
        throw error;
    }
};

// fin de actualizados con autenticación


const ClientService = {
    getClientDataById,
    createClient,
    changePassword,
    updateClient,
    updateClientSelf,
    getWhatsAppQr,
    getWhatsAppPairingCode,
    getAllClients,
    addStaff,
    deleteStaff,
    updateStaffData,
    updatePaymentSettings,
    updateAssistantSettings,
    getAssistantUsage,
    subscribeNotifications,
    subscribeStaffNotifications,
    reorderServices,
    registerPayment,
    getPayments,
    getSystemConfig,
    updateSystemConfig
};

export default ClientService;
